import { render, staticRenderFns } from "./ButtonModals.vue?vue&type=template&id=470968e1&"
import script from "./ButtonModals.vue?vue&type=script&lang=js&"
export * from "./ButtonModals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports